export default __webpack_public_path__ + "earth-globe.png";